import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "platformStats",
        meta: {
            title: "Platform Stats",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.ANALYTICS_ALL],
        },
        path: "/manage/platformStats",
        component: () => import("@/views/pages/platformStats/index.vue"),
    }
]